<template>
  <div style="background-color: #f2f2f2;height: 100%;" class="userStaff">
    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
      用户列表
    </div>
    <div style="padding: 20px;">

      <div>

        <el-row style="float: right">
          <el-form inline>
            <div>
              <el-col>
                <el-form-item>
                  <el-input placeholder="请输入姓名" v-model="name" clearable
                            style="width:200px;margin-right:10px"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" clearable
                            style="width:200px;margin-right:10px"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="governmentCode" clearable placeholder="请选择政府" style="margin-right:10px">
                    <el-option
                            v-for="item in governmentValue"
                            :key="item.governmentCode"
                            :label="item.name"
                            :value="item.governmentCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
              </el-col>
            </div>
          </el-form>

        </el-row>


        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>

          <el-table
              :data="tableData"
              :height="th"
              border
              v-loading="loading"
              style="width: 100%;">

            <el-table-column prop="name" label="姓名"></el-table-column>

            <el-table-column prop="phone" label="手机"></el-table-column>

            <el-table-column prop="governmentName" label="政府"></el-table-column>

            <el-table-column prop="userType" :formatter="getUserType" label="用户类型"></el-table-column>

            <el-table-column prop="createTime" label="注册日期" width="180px">
              <template slot-scope="scope">
                <p>{{ scope.row.createTime | timefilters }}</p>
              </template>
            </el-table-column>


            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" @click="handleEditPwd(scope.row)">修改密码</el-button>
              </template>
            </el-table-column>

          </el-table>

          <el-dialog
              title="修改金额"
              :visible.sync="updateBalance"
              width="30%"
              >

            <el-input placeholder="请输入修改金额" v-model="balance" maxlength="11" clearable
                      style="width:200px;margin-left: 150px;"></el-input>
            <span slot="footer" class="dialog-footer">
            <el-button @click="updateBalance = false">取 消</el-button>
            <el-button type="primary" @click="beforeUpdate">确 定</el-button>
            </span>

          </el-dialog>


          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">
              共{{ totalItems }}条（{{ Math.ceil(totalItems /pageSize) }}页）
            </div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


        </template>
      </div>

    </div>
    <el-dialog title="密码修改" :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh'
              :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
          <el-button @click="batchDialog=false">取 消</el-button>
          <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>

    <!--        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>-->
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:governmentValue="governmentValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    <ElderlyDetails ref="myElderlyDetails" v-show="showModalElderlyDetails" v-on:close="closeElderlyDetails" v-bind:elderlyAllType="elderlyAllType"></ElderlyDetails>
  </div>
</template>

<script>


import {getStaffCode} from "@/utils/auth";
import {timeStr} from "../../common/times";
import {hex_md5} from "../../common/Base64MD5";
import Edit from "./Edit";
import ElderlyDetails from "@/views/User/ElderlyDetails";
import elderly from "@/common/status";

export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data() {
    return {
      elderlyCode:'',
      balance:'',
      updateBalance:false,
      loading: false,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      userType: '',
      phone: '',
      idCard: '',
      elderlyAllType: elderly,
      governmentValue: [],
      governmentCode: '',
      elderlyType: elderly.serviceType,
      cardInsideCode: '',
      options: [{
        value: -1,
        label: '全部状态'
      }, {
        value: 0,
        label: '默认'
      }, {
        value: 1,
        label: '已通过'
      }, {
        value: 2,
        label: '被禁用'
      }],
      status: -1,
      showModalElderlyDetails: false,
      showModalOldestDetails: false,
      showModalAdd: false,
      showModalEdit: false,
      roleList: null,
      editStaff: null,
      name: '',
      th: 0,
      batchDialog:false,
      row:null,
      password:''
    }
  },
  created() {
    this.init();
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components: {
    Edit, ElderlyDetails
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      console.log(val);
      this.th = val;
    },
  },
  methods: {
    init() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    beforeUpdate(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/UpdateBalance",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          balance:this.balance,
          elderlyCode:this.elderlyCode
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
                this.updateBalance=false;
              this.$message({type: 'info', message: '修改成功'});
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    handleEditPwd(row){
      this.batchDialog = true;
      this.row = row
      //  this.$prompt('请输入6位以上的新密码', '密码修改', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     // inputPattern: /^.{6,0}$/,
      //     inputType:'password',
      //     inputErrorMessage: '密码格式不正确'
      //   }).then(({ value }) => {
          
      //     console.log(value)
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '取消输入'
      //     });       
      //   });
    },
    editPassword(){
      if(this.password.length<6){
        this.message.error('请输入正确格式的密码')
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'User/ChangePwd',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode:this.row.userCode,
          password: this.password,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.batchDialog = false;
          this.$message.success('密码修改成功！')
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        } else {
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },
    closeElderlyDetails: function () {
      this.showModalElderlyDetails = !this.showModalElderlyDetails;
    },
    closeOldestDetails: function () {
      this.showModalOldestDetails = !this.showModalOldestDetails;
    },
    handleInfo(index, row) {
      this.$refs.myElderlyDetails.init(row, true);
      this.showModalElderlyDetails = !this.showModalElderlyDetails;
    },
    handleInfo1(index, row) {
      this.$refs.myOldestDetails.init(row, true);
      this.showModalOldestDetails = !this.showModalOldestDetails;
    },
    roleNames() {
      return '管理员'
    },
    // search(){
    //     this.currentPage = 1;
    //     this.getList();
    // },
    getUserType(row) {
      var userType = row.userType;
      if (userType === 0) {
        return "默认"
      } else if (userType === 1) {
        return "老人"
      } else if (userType === 2) {
        return "子女"
      } else if (userType === 3) {
        return "商家"
      } else if (userType === 4) {
        return "服务人员"
      }
    },
    IsElderly(row) {
      var isElderly = row.isElderly
      if (isElderly === 1) {
        return "否"
      } else if (isElderly === 2) {
        return "是"
      }
      if (isElderly === 0) {
        return "否"
      }
    },
    IsOldest(row) {
      var isOldest = row.isOldest
      if (isOldest === 1) {
        return "否"
      } else if (isOldest === 2) {
        return "是"
      }
      if (isOldest === 0) {
        return "否"
      }
    },

    getList() {
      this.loading = true;
      var governmentCode='00000000-0000-0000-0000-000000000000'
      if(this.governmentCode)governmentCode=this.governmentCode
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'User/PageForAdmin',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          phone: this.phone,
          name: this.name,
          governmentCode: governmentCode
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    changeStatus: function (selVal) {
      this.status = selVal;
    },


    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    handleEditBalance(index, row) {
      this.balance='';
      this.elderlyCode=row.elderly.elderlyCode;
      this.updateBalance =!this.updateBalance;
    },
    handleDelete(index, row) {
      console.log(index, row);
    },


    statusTitle(row) {
      if (row.status == 0) {
        return "默认";
      }
      if (row.status == 1) {
        return "已通过";
      }
      if (row.status == 2) {
        return "被禁用";
      }
      return "其它";
    },


  }
}
</script>

<style lang="scss" scoped>
.userStaff /deep/ .el-form-item {
  margin-bottom: 0;
}
</style>
